import React from 'react';

import RecipeDetails from 'components/Recipe/RecipeDetails';
import RelatedContent from 'components/RelatedContent';
import { Author } from '../Author';

import { OneByOne } from '../OneByOne';
import { OneByOneProduct } from '../OneByOneProduct';
import { TwoByOne } from '../TwoByOne';
import { TwoByThree } from '../TwoByThree';
import { ShopListByOne } from '../ShopListByOne';


const CARD_MAP = {
  default: TwoByOne,
  twoOneSmall: TwoByOne,
  twoOneLarge: TwoByOne,
  twoOneLargeItems: TwoByOne,
  oneOne: OneByOne,
  shopListByOneProduct: ShopListByOne,
  oneOneProduct: OneByOneProduct,
  twoThreePortrait: TwoByThree,
  author: Author,
};

const CARD_VARIANT = {
  twoOneLarge: 'large',
  twoOneLargeItems: 'large',
};

const ADDITIONAL_SELLER_CARD_MAP = {
  default: OneByOne,
  oneOne: OneByOne,
  shopListByOneProduct: ShopListByOne,
};

/**
 * Renders bacon cards depending on selected number and size
 * @param {object} props - The component props.
 * @param {object} props.content The content data for bacon cards.
 * @param {boolean} props.shouldShowAdditionalSeller Indicates if to show the additional seller.
 * @param {boolean} props.showItemDescriptions Indicates if to show the description.
 * @param {object} props.item Contains data with details for each card
 * @param {number} props.totalNumberOfCards Determines how many cards to render
 * @param {number} props.indexOffset
 * @param {string} props.containerClasses Css classes for styling
 * @param {Function} props.setMbtBaconClickTracking Set tracking on click
 * @param {string} props.vertical The vertical type
 * @param {Function} props.trackLink Function for tracking links
 * @param {Function} props.onAddProduct Adds product to cart
 * @param {boolean} props.shouldOpenLinkInNewTab Indicates if a link opens in a new tab.
 * @returns {React.ReactElement} The rendered component.
 */
function CardSelector({
  content,
  shouldShowAdditionalSeller,
  showItemDescriptions,
  item,
  totalNumberOfCards,
  indexOffset,
  containerClasses,
  setMbtBaconClickTracking,
  vertical,
  trackLink = null,
  onAddProduct = null,
  shouldOpenLinkInNewTab = false,
}) {
  const {
    type = null,
    subType,
    metadata,
    cardType = undefined,
  } = content;
  // AUTHOR selection logic

  const author = item?.authors?.[0];
  const authorName = author?.person?.name;
  const authorPhotoUrl = author?.person?.primaryImage?.url?.primary;

  if (cardType === 'author' && !authorName && !authorPhotoUrl) {
    return null;
  }
  //* *** */

  const { title } = metadata || {};

  const {
    metadata: cardMetadata = {},
    item: card,
    related,
  } = item;
  //* *** */
  // CARD selection logic
  const cardMap = shouldShowAdditionalSeller ? ADDITIONAL_SELLER_CARD_MAP : CARD_MAP;
  const Card = cardMap[subType] ?? (cardMap[cardType] ?? cardMap.default);
  const variant = CARD_VARIANT[subType];
  //* *** */

  const cookTime = card?.cookTime || item?.cookTime;
  const prepTime = card?.prepTime || item?.prepTime;

  return (
    <div
      className={containerClasses}
      data-test-id="card"
      data-testid="baconCardWrapper"
    >
      <Card
        totalNumberOfCards={totalNumberOfCards}
        indexOffset={indexOffset}
        card={item}
        title={title}
        openInNewTab={shouldOpenLinkInNewTab || cardMetadata.openInNewTab}
        pkgType={type}
        showEyebrow={metadata?.showEyebrow}
        showTimestamp={metadata?.showTimestamp}
        trackBacon={setMbtBaconClickTracking}
        trackLink={trackLink}
        shouldShowAdditionalSeller={shouldShowAdditionalSeller}
        onAddProduct={onAddProduct}
        shouldShowDescription={showItemDescriptions}
        variant={variant}
        vertical={vertical}
      />
      {cookTime || prepTime ? (
        <RecipeDetails
          type={item?.type}
          cookTime={cookTime}
          prepTime={prepTime}
        />
      ) : null}
      {related ? <RelatedContent related={related} /> : null}
    </div>
  );
}

export { CardSelector };
